import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/common_action/fillList_action";
import {
  get_userDetails_action,
  deleteUser_action,
  addUpdate_user_action,
  suspendUser_action,
} from "../../../actions/adminModule_action/user_action";

import {
  roleActionId,
  responseError,
  toastSuccess,
  toastError,
} from "../../../utils/constants";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment-timezone";
import Header from "../../../common_components/Header";
import { emailValidator, mobileNoValidator } from "../../../utils/Validator";
import { forgetPassword_action } from "../../../actions/user_login_auth_actions/user_login_auth_action";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";

class UserAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      user_id: "",
      role_id: "",
      userAdd: false,
      userUpdate: false,
      designation: "",
      roleList: [],
      Name: "",
      phone: "",
      email: "",
      userDate: "",
      createdBy: "",
      createdDate: "",
      deletedBy: "",
      deletedDate: "",
      modifiedBy: "",
      modifiedDate: "",
      isAccordionExpanded: false,
      isCollapse: false,
      is_active: 1,
      Password: "",
      confirmPassword: "",
      role_idErr: "",
      designationErr: "",
      NameErr: "",
      emailErr: "",
      phoneErr: "",
      PasswordErr: "",
      confirmPasswordErr: "",
      resetView: false,
    };
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
          sessionStorage.getItem("role_id") == 2 ? (
              this.props.navigate("/login")
          ) :<></>
      }
  }, 10);
    this.getFillList(roleActionId, sessionStorage.getItem("user_id"), "", "");

    this.setState({
      userAdd:
        this.props.location.state != null &&
          this.props.location.state.userAdd != null
          ? this.props.location.state.userAdd
          : false,

      userUpdate:
        this.props.location.state != null &&
          this.props.location.state.userUpdate != null
          ? this.props.location.state.userUpdate
          : false,

      user_id:
        this.props.location.state != null &&
          this.props.location.state.user_id != null
          ? this.props.location.state.user_id
          : "",
    });

    this.props.location.state != null &&
      this.props.location.state.userUpdate &&
      this.getUserDetails();
  }

  inputValidate() {
    const { Name, email, phone, role_id } = this.state;
    let isValid = true;

    this.setState({
      NameErr: "",
      emailErr: "",
      phoneErr: "",
      role_idErr: "",
    });

    if (Name == null || Name == "") {
      this.setState({ NameErr: "Please enter Name" });
      isValid = false;
    }

    if (phone == null || phone == "") {
      this.setState({ phoneErr: "Please enter Phone number" });
      isValid = false;
    } else {
      const cleanedPhone = phone.replace(/\D/g, ""); // Clean phone number
      const phoneRegex = /^\d{10}$/; // Validate 10 digits
      const validPhone = phoneRegex.test(cleanedPhone);
      if (!validPhone) {
        this.setState({ phoneErr: "Please enter a valid number" });
        isValid = false;
      }
    }

    if (role_id == "" || role_id === "Select" ) {
      this.setState({ role_idErr: "Please select Role" });
      isValid = false;
    }

    if (email == null || email == "") {
      this.setState({ emailErr: "Please enter Email Address" });
      isValid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const validMail = emailRegex.test(email);
      if (!validMail) {
        this.setState({ emailErr: "Please enter a valid email" });
        isValid = false; // Set to false if the email is invalid
      }
    }

    return isValid;
  }

  Email(e) {
    const email = e.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(email);
    this.setState({
      email: email,
      emailErr: isValid ? "" : "Invalid email address",
    });
  }

  Name(e) {
    const inputValue = e.target.value;
    const regex = /^[a-zA-Z\s]*$/;
    if (regex.test(inputValue)) {
      const finalValue = e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      this.setState({
        Name: finalValue,
        NameErr: "",
      });
    } else {
      toastError("Numbers not allowed");
    }
  }

  Phone(e) {
    const phoneInput = e.target.value;
    const cleanedPhone = phoneInput.replace(/\D/g, "");
    const phoneRegex = /^\d{10}$/;
    const isValid = phoneRegex.test(cleanedPhone);
    this.setState({
      phone: cleanedPhone,
      phoneErr: isValid ? "" : "Invalid phone number. Must be 10 digits.",
    });
  }

  getFillList(value, user_id, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        user_id === "" || user_id === null ? null : user_id,
        keyword !== "" ? keyword : null,
        keyvalue !== "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error !== 1) {
          if (value === roleActionId) {
            this.setState({ roleList: data.data, isLoading: false });
          }
        } else {
          this.setState({ isLoading: false });
          responseError(data); // Ensure this is bound correctly
        }
      })
      .catch((e) => {
        this.setState({ isLoading: false });
      });
  }
  getUserDetails() {
    const { mainCityList, getCityId } = this.state;
    this.setState({ isLoading: true });
    var user_id =
      this.props.location.state != null &&
        this.props.location.state.user_id != null
        ? this.props.location.state.user_id
        : "";
    this.props
      .get_userDetails_action(user_id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            user_id: data.data[0]["user_id"],
            role_id: data.data[0]["role_id"],
            Name: data.data[0]["name"],
            designation_name: data.data[0]["designation_name"],
            designation: data.data[0]["designation"],
            phone: data.data[0]["contact_no"],
            email: data.data[0]["email_address"],
            // userDate: data.data[0]['DateOfBirth'],
            Password: data.data[0]["Password"],
            confirmPassword: data.data[0]["Password"],
            // userDateOfBirth: data.data[0]['DateOfBirth'] != null ? moment(data.data[0]['DateOfBirth'], 'DD-MM-YYYY').toDate() : null,
            createdBy: data.data[0]["created_by_user"],
            createdDate:
              data.data[0]["created_date"] != null
                ? moment(
                  data.data[0]["created_date"],
                  "DD-MM-YYYY hh:mm A"
                ).format("DD-MM-YYYY")
                : null,

            deletedBy: data.data[0]["deleted_by_user"],
            deletedDate:
              data.data[0]["deleted_date"] != null
                ? moment(data.data[0]["deleted_date"], "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY")
                : null,
            modifiedBy: data.data[0]["modified_by_user"],
            modifiedDate:
              data.data[0]["modified_date"] != null
                ? moment(data.data[0]["modified_date"], "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY")
                : null,
            is_active:
              data.data[0]["is_active"] != null
                ? data.data[0]["is_active"]
                : null,
          });
          this.setState({ isLoading: false });
        } else {
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  addUpdateUser() {
    const { Name, email, phone, role_id, designation, cityId } = this.state;
    var user_id =
      this.props.location.state != null &&
        this.props.location.state.user_id != null
        ? this.props.location.state.user_id
        : "";
    this.setState({ isLoading: true });
    const isValid = this.inputValidate();
    if (isValid) {
      this.props
        .addUpdate_user_action(
          user_id,
          Name,
          email,
          phone,
          designation,
          role_id
        )
        .then((data) => {
          if (data.error != 1) {
            this.props.navigate("/user");
            this.setState({ isLoading: false });
          } else {
            responseError(data);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toastError("Please enter all mandatory fields");
      this.setState({ isLoading: false });
    }
  }

  handleCancel() {
    this.props.navigate("/user");
  }
  handleSuspend() {
    const { user_id } = this.state;
    this.setState({ isLoading: true });
    this.props
      .suspendUser_action(user_id)
      .then((data) => {
        if (data.error != 1) {
          this.props.navigate("/user");
          this.getUserList();
          this.setState({ isLoading: false, show: false });
          toast.success("Deleted SuccessFully!", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else {
          this.responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleDelete() {
    const { user_id } = this.state;
    this.setState({ isLoading: true });
    this.props
      .deleteUser_action(user_id)
      .then((data) => {
        if (data.error != 1) {
          this.props.navigate("/user");
          this.getUserList();
          this.setState({ isLoading: false, show: false });
          toast.success("Deleted SuccessFully!", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else {
          this.responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  resetInitiate(e) {
    const { email } = this.state;
    var errMsg = emailValidator(email);
    if (errMsg != "") {
      toast.error(errMsg != "" ? errMsg : "", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    } else {
      if (email != " ") {
        this.setState({ isLoading: true });
        this.isCheckEmailPresent(e);
      }
    }
  }

  isCheckEmailPresent(e) {
    e.preventDefault();
    const { email } = this.state;
    this.props
      .forgetPassword_action(email)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(`Reset password link Sent on ${email}`);
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false, email: "" });
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  checkbox() {
    const { is_active } = this.state;
    this.setState({
      is_active: !is_active,
    });
  }

  render() {
    const {
      isLoading,
      Name,
      role_id,
      roleList,
      designation,
      designationErr,
      phone,
      email,
      createdBy,
      createdDate,
      deletedBy,
      deletedDate,
      modifiedBy,
      modifiedDate,
      userAdd,
      isCollapse,
      userUpdate,
      is_active,
      role_idErr,
      NameErr,
      emailErr,
      phoneErr,
    } = this.state;

    return (
      <>
        {isLoading ? (
          <Loader></Loader>
        ) : (
          <>
            <main id="main">
              
                          <div className="website-view">
                            <Header data={[8]} />
                          </div>
                          <div className="mobile-view">
                            <MobileHeader data={[8]} />
                          </div>
              <section class='header_margin_top'>
                <div class="container-fluid">
                    <div class="page-header">
                    <h2 class="mb-1 dashboard-tit  py-0 blog-name">
                        {userAdd ? "Add" : "Update"} User
                      </h2>
                      <div class="Service_display pt-2">
                        <h6 class="Services_Active_or_Not">
                          {is_active ? "Active" : "InActive"}
                        </h6>
                        <div class="checkbox checbox-switch">
                          <label class="switch">
                            <input type="checkbox" selected={is_active} checked={is_active} value={is_active} onClick={(e) => userUpdate ? this.checkbox(e) : ""} />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="card Service_fields">
                      <div class="card-body">
                        <div class="row">
                          <div class="form-group col-md-3">
                            <label for="inputZip">
                              Name <span class="mendatory_class">*</span>{" "}
                            </label>
                            <input
                              type="text"
                              value={Name}
                              maxLength={100}
                              // disabled={is_active == '0'}
                              onChange={(e) => this.Name(e)}
                              class="form-control"
                              id="fname"
                              name="name"
                            />
                            <span className="text-danger text-start text-left d-block mt-1">
                              {NameErr}
                            </span>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="inputZip">
                              {" "}
                              Email <span class="mendatory_class">*</span>
                            </label>
                            <input
                              type="email"
                              value={email}
                              disabled={userUpdate || is_active == "0"}
                              onChange={(e) => this.Email(e)}
                              maxLength={100}
                              class="form-control"
                              id="email"
                              name="email"
                            />
                            <span className="text-danger text-start text-left d-block mt-1">
                              {emailErr}
                            </span>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="inputZip">
                              {" "}
                              Mobile No<span class="mendatory_class">*</span>
                              {/* <span class="mendatory_class">*</span>  */}
                            </label>
                            <input
                              type="tel"
                              class="form-control"
                              id="phone"
                              name="phone"
                              maxlength="10"
                              onkeypress="return event.charCode >= 48 &amp;&amp; event.charCode <= 57"
                              value={phone}
                              // disabled={is_active == '0'}
                              onChange={(e) => this.Phone(e)}
                              maxLength={10}
                            />
                            <span className="text-danger text-start text-left d-block mt-1">
                              {phoneErr}
                            </span>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="inputZip">Designation</label>
                            <input
                              type="email"
                              value={designation}
                              onChange={(e) =>
                                this.setState({
                                  designation: e.target.value,
                                  designationErr: "",
                                })
                              }
                              maxLength={100}
                              class="form-control"
                              id="email"
                              name="email"
                            />
                            <span className="text-danger text-start text-left d-block mt-1">
                              {designationErr}
                            </span>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="inputZip">
                              Role <span class="mendatory_class">*</span>{" "}
                            </label>
                            <select
                              class="form-select"
                              value={role_id}
                              onChange={(e) =>
                                this.setState({
                                  role_id: e.target.value,
                                  role_idErr: "",
                                })
                              }
                            >
                              <option>Select</option>
                              {roleList.length > 0 &&
                                roleList.map((item) => (
                                  <option key={item.role_id} value={item.role_id}>
                                    {item.roleName}
                                  </option>
                                ))}
                            </select>
                            <span className="text-danger text-start text-left d-block mt-1">
                              {role_idErr}
                            </span>
                          </div>
                        </div>
                        {userUpdate ? (
                          <div class="system_info">
                            <div class="row row_margin collpase_arrow_cursor pb-1">
                              <div class="col-md-6 col-sm-6 col-7">
                                <span
                                  data-toggle="collapse"
                                  data-target="#Sys_info"
                                  aria-expanded="false"
                                  class="sys-text"
                                >
                                  {!isCollapse ? (
                                    <>
                                      <div
                                        onClick={() =>
                                          this.setState({
                                            isCollapse: !isCollapse,
                                          })
                                        }
                                      >
                                        <i
                                          class="fa fa-chevron-right "
                                          style={{
                                            fontSize: "12px",
                                            color: "#898989",
                                          }}
                                        ></i>
                                        <span
                                          class="heading_text"
                                          style={{ paddingLeft: "5px" }}
                                        >
                                          System Info
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div
                                        onClick={() =>
                                          this.setState({
                                            isCollapse: !isCollapse,
                                          })
                                        }
                                      >
                                        <i
                                          class="fa fa-chevron-down"
                                          style={{
                                            fontSize: "12px",
                                            color: "#898989",
                                          }}
                                        ></i>
                                        <span
                                          class="heading_text"
                                          style={{ paddingLeft: "5px" }}
                                        >
                                          System Info
                                        </span>
                                      </div>
                                    </>
                                  )}
                                </span>
                              </div>
                              <div class="col-md-6 col-sm-6 col-5 text-right"></div>
                            </div>
                            <hr
                              style={{
                                marginTop: "0px",
                                marginBottom: "15px",
                                border: "1px solid #c0c0c0",
                              }}
                            />
                            {/* <div class="CRM_details_div collapse" id="Sys_info" > */}
                            {isCollapse ? (
                              <div class="" id="Sys_info">
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group">
                                        <label class="sys_info_label" for="email">
                                          Created By
                                        </label>
                                        <p class="Sys_info_style">{createdBy}</p>
                                      </div>
                                      <div class="form-group">
                                        <label class="sys_info_label" for="email">
                                          Created Date
                                        </label>
                                        <p class="Sys_info_style">
                                          {createdDate}
                                        </p>
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group">
                                        <label class="sys_info_label" for="email">
                                          Modified By
                                        </label>
                                        <p class="Sys_info_style">{modifiedBy}</p>
                                      </div>
                                      <div class="form-group">
                                        <label class="sys_info_label" for="email">
                                          Modified Date
                                        </label>
                                        <p class="Sys_info_style">
                                          {modifiedDate}
                                        </p>
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group">
                                        <label class="sys_info_label" for="email">
                                          Deleted By
                                        </label>
                                        <p class="Sys_info_style">{deletedBy}</p>
                                      </div>
                                      <div class="form-group">
                                        <label class="sys_info_label" for="email">
                                          Deleted Date
                                        </label>
                                        <p class="Sys_info_style">
                                          {deletedDate}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}

                        <div class="row">
                          <div class="col-md-12">
                            {userAdd ? (
                              <button onClick={(e) => this.addUpdateUser(e)} class="btn btn-outline-success mr-2">Save</button>
                            ) : (
                              <button onClick={(e) => this.addUpdateUser(e)} class="btn btn-outline-success  mr-2">Update</button>
                            )}
                            <button onClick={(e) => this.handleCancel(e)}class="btn btn-outline-secondary  mr-2">Back</button>
                            {userUpdate ? (
                              <>
                                <button onClick={() => this.handleSuspend()} class="btn btn-outline-warning mr-2">Suspend</button>
                                <button onClick={() => this.handleDelete()} class="btn btn-outline-danger  mr-2">Delete</button>
                                <button onClick={(e) => this.resetInitiate(e)} class="btn btn-outline-info  mr-2">Reset Password</button>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </section>
            </main>
          </>
        )}
                        <Footer/>
                        <ToastContainer />
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    get_userDetails_action,
    addUpdate_user_action,
    suspendUser_action,
    deleteUser_action,
    forgetPassword_action,
  })(UserAU)
);
